var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUtility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4C13.55 4 14 4.45 14 5V8H26V5C26 4.45 26.45 4 27 4C27.55 4 28 4.45 28 5V8H30C32.2062 8 34 9.79375 34 12V30C34 32.2062 32.2062 34 30 34H10C7.79375 34 6 32.2062 6 30V12C6 9.79375 7.79375 8 10 8H12V5C12 4.45 12.45 4 13 4ZM30 10H10C8.89375 10 8 10.8938 8 12V14H32V12C32 10.8938 31.1063 10 30 10ZM32 16H8V30C8 31.1063 8.89375 32 10 32H30C31.1063 32 32 31.1063 32 30V16Z",
    fill: "#73A955"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtility);
export default __webpack_public_path__ + "static/media/utility.fa6b13a368736e30aa1993ee4ed595f1.svg";
export { ForwardRef as ReactComponent };